import axios from 'axios';

// 获取Access Token
export async function getAccessToken(apiKey, secretKey) {
  const url = `baidubce/oauth/2.0/token?grant_type=client_credentials&client_id=${apiKey}&client_secret=${secretKey}`;
  const response = await axios.get(url);
  return response.data.access_token;
}

// 调用OCR API
export async function callOcrApi(accessToken, imageBase64, options = {}) {
  const url = `baidubce/rest/2.0/ocr/v1/${options.recognizeType || 'general_basic'}?access_token=${accessToken}`;
  const formData = new FormData();
  formData.append('image', imageBase64);
  if (options.recognizeGranularity) {
    formData.append('recognize_granularity', options.recognizeGranularity);
  }

  const response = await axios.post(url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
}

// 调用文档解析 API
export async function callDocumentApi(accessToken, filename, imageBase64, options = {}) {
  const url = `baidubce/rest/2.0/brain/online/v2/parser/${options.recognizeType || 'task'}?access_token=${accessToken}`;
  const formData = new FormData();
  formData.append('file_data', imageBase64);
  formData.append("file_name", filename);
  if (options.recognizeGranularity) {
    formData.append('recognize_granularity', options.recognizeGranularity);
  }

  const response = await axios.post(url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  if (response.data.error_code == 0) {
	return queryDocument(accessToken, response.data["result"]["task_id"])
  }
  return response.data;
}

export async function recognizeText(accessToken, dataBase64, callback) {
	try {
		const result = await callOcrApi(accessToken, dataBase64, {
			recognizeType: 'general_basic',
		});
		if (callback) {
			callback(result.words_result.map(item => item.words).join('\n'));
		}
	} catch (error) {
		console.error('OCR识别失败:', error);
		alert('识别失败，请重试');
	}
}

export async function getImageAsBase64FromRemoteUrl(accessToken, url, callback) {
	try {
	  const response = await fetch(url);
	  const blob = await response.blob();
	  return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(blob);
		reader.onloadend = () => {
			resolve(reader.result);
			recognizeText(accessToken, reader.result.split(',')[1], callback);
		};
		reader.onerror = reject;
	  });
	} catch (error) {
	  console.error('Error converting image to base64:', error);
	  return null;
	}
}

export function getDataBase64ByFile(accessToken, file, callback) {
	// 读取文件内容为 Blob 数据
	const reader = new FileReader();
	reader.readAsDataURL(file); // 或者使用 readAsArrayBuffer 根据需要选择方法
	reader.onload = (e) => {
		recognizeText(accessToken, e.target.result.split(',')[1], callback);
	};
}

//加载合同数据
export function loadContractData(data, companyName, orderCompanyKV, productIdMapping, buildDetailItem, 
	dataForm, onChangeCompanyId) {
	for(var i = data.companyNames.length - 1; i > -1; i--) {
		if (companyName == data.companyNames[i]) {
			data.companyNames.splice(i, 1);
		}
	}
	if (data.companyNames.length > 0) {
		let index = orderCompanyKV.findIndex(item => {
			if (item.value === data.companyNames[0]) {
				return true;
			}
		})
		if (index > -1) {
			dataForm["orderCompanyId"]=orderCompanyKV[index].key;
			onChangeCompanyId(dataForm["orderCompanyId"]);
			dataForm["orderCompanyName"]=data.companyNames[0];
		}
	}
	dataForm["taxIncluded"] = true;
	let itemNum = 0;
	for(var i in data.details) {
		let detail = data.details[i];
		let orderDetail = {};
		let productInfo = productIdMapping[detail.model];
		if (!productInfo) {
			continue;
		}
		orderDetail["productInfo"] = productInfo.split(",");
		orderDetail["num"] = detail.num;
		orderDetail["unit"] = "个";
		orderDetail["price"] = detail.price.replace("￥", "")
		.replace(",", "").replace("，","").replace(".00", "");
		orderDetail["remark"] = "";
		buildDetailItem(orderDetail);
		itemNum = itemNum + Number(detail.num);
	}
	if (data.total) {
		dataForm["totalMoney"] = data.total;
	}
	dataForm["itemNum"] = itemNum;
}